// import React from 'react';

interface TableSwitcherProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
}
/**
 * Tabs for: All Items | All Properties
 * @param param0
 * @returns
 */
const TableSwitcher = ({ activeTab, setActiveTab }: TableSwitcherProps) => {
  const handleTabChange = (tab: string) => {
    setActiveTab(tab);
  };

  return (
    <>
      <ul className="nav nav-tabs">
        <li className="nav-item me-2">
          <button
            className={`nav-link ${activeTab === 'table1' ? 'active' : ''}`}
            onClick={() => handleTabChange('table1')}
          >
            All Items
          </button>
        </li>
        <li className="nav-item me-2">
          <button
            className={`nav-link ${activeTab === 'table2' ? 'active' : ''}`}
            onClick={() => handleTabChange('table2')}
          >
            All Properties
          </button>
        </li>
      </ul>
      <div className="tab-content">
        <div
          className={`tab-pane fade ${
            activeTab === 'table1' ? 'show active' : ''
          }`}
          id="table1"
        >
          <table className="table"></table>
        </div>
        <div
          className={`tab-pane fade ${
            activeTab === 'table2' ? 'show active' : ''
          }`}
          id="table2"
        >
          <table className="table"></table>
        </div>
      </div>
    </>
  );
};

export default TableSwitcher;
